import {User} from "domain-models"
import {privateChannels} from "services/websockets/channels/private"
import _ from "lodash"

export const joinChannels = (user: User) => {
  if (user && !_.isEmpty(user)) {
    privateChannels(user)
  }
}
